import script from "./BasePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./BasePagination.vue?vue&type=script&setup=true&lang=js"

import "./BasePagination.vue?vue&type=style&index=0&id=bcf65e46&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcf65e46"]])

export default __exports__